export enum fleetStages {
  PRODUCTION = 'Production',
  STAGING = 'Staging',
  PILOT = 'Active Pilot',
  COMPLETED_PILOT = 'Completed Pilot',
  PREPILOT = 'Pre-Pilot',
  PREPRODUCTION = 'Pre-Production',
  INTERNAL = 'Internal',
  TEST = 'Test',
}
